import WOTemplateList from './WOTemplateList';

export default WOTemplateList;
export * from './WOTemplateList';
